import { render } from "./Table3.vue?vue&type=template&id=3388a811&scoped=true"
import script from "./Table3.vue?vue&type=script&lang=js"
export * from "./Table3.vue?vue&type=script&lang=js"

import "./Table3.vue?vue&type=style&index=0&id=3388a811&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3388a811"]])

export default __exports__